// @flow
import styled from 'styled-components';

export const Button = styled.button`
  border: 0;
  background: none;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    user-select: none;
  }
`;

export const WrapperButton = styled(Button)`
  width: 100%;
  height: 100%;
`;

export const StrippedButton = styled.button`
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
`;
